import { ShippingInfo } from '@app/models/prices';
import { createReducer, on } from '@ngrx/store';
import * as ShippingPricesActions from './actions';

export const featureKey = 'shipping-prices';

export interface State {
	data: ShippingInfo | undefined;
	loading: boolean;
	loaded: boolean;
}

export const initialState: State = {
	data: undefined,
	loading: false,
	loaded: false,
};

export const reducer = createReducer(
	initialState,

	on(ShippingPricesActions.load, state => ({
		...state,
		loading: true,
	})),
	on(ShippingPricesActions.loadSuccess, (state, { prices }) => ({
		...state,
		data: prices,
		loading: false,
		loaded: true,
	})),
	on(ShippingPricesActions.loadFailed, state => ({
		...state,
		loading: false,
		loaded: false,
	}))
);
